import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description: "Play with the parameters to see their effect on the frequency response and sensitivity.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0415/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
